import { POLYGON } from "./polygon.js";
import { SEPOLIA } from "./sepolia.js";
export const CHAINS = [SEPOLIA, POLYGON];
export { SEPOLIA, POLYGON };
